import moment from "moment";
import React, { Component } from "react";
//i18n
import { withNamespaces } from "react-i18next";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Button, Card, CardBody, Col, Row } from "reactstrap";
import WarningList from "../../components/Lists/WarningList";
import { alertsFields } from "../../constants/alerts_fields";
//Import actions redux
import { getWarnings } from "../../store/actions";
import "./datatables.scss";

class Alerts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: JSON.parse(localStorage.getItem("authUser")),
      warninglist: null,
    };
  }

  componentDidMount() {
    this.props.getWarnings(this.state.user);
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.loadingGetWarning === false &&
      prevProps.loadingGetWarning === true
    ) {
      console.log(this.props.warnings);
      let warnings = this.props.warnings;
      if (warnings) {
        this.prepareData(warnings);
      }
    }
  }

  prepareData(warnings) {
    console.log(warnings);
    let columns = alertsFields;
    let rows = [];
    warnings.forEach((warning) => {
      warning["beginTime"] = moment(warning["beginTime"]).format(
        "DD/MM/YYYY hh:mm"
      );
      rows.push(warning);
    });
    let data = { columns, rows };
    this.setState({ warninglist: data });
  }
  refresh(event) {
    event.preventDefault();
    this.setState({ warninglist: null });
    this.props.getWarnings(this.state.user);
  }

  render() {
    if (!this.state.warninglist) {
      return (
        <React.Fragment>
          <div>{this.props.t("Cargando...")}</div>
        </React.Fragment>
      );
    }
    return (
      <React.Fragment>
        <div className="page-content">
          <div className="container-fluid">
            <Row>
              <Col className="col-12">
                <Button
                  onClick={(event) => this.refresh(event)}
                  color="primary"
                  className="btn btn-primary buttonStatus usersButtons"
                >
                  {" "}
                  <i size="lg" className="mdi  mdi-refresh"></i>
                </Button>

                <Card>
                  <CardBody>
                    {/* <CardTitle>Stripped example </CardTitle>
                    <CardSubtitle className="mb-3">
                      mdbreact DataTables has most features enabled by default, so
                      all you need to do to use it with your own tables is to call
                    the construction function:{" "}
                      <code>&lt;MDBDataTable striped /&gt;</code>.
                  </CardSubtitle> */}

                    <WarningList warninglist={this.state.warninglist} />
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateProps = (state) => {
  const { errorGetWarning, loadingGetWarning, warnings, successGetWarning } =
    state.GetAllWarnings;
  return { errorGetWarning, loadingGetWarning, warnings, successGetWarning };
};

export default withRouter(
  connect(mapStateProps, {
    getWarnings,
  })(withNamespaces()(Alerts))
);
